// Defer a heavy read (the volume-by-tag chart workouts) off the initial-paint
// frame: it competes with the rest of the mount for the network. Mobile's
// twin defers via InteractionManager; the browser equivalent is
// requestIdleCallback, falling back to a macrotask where it's unavailable
// (Safari/older WebKit-based RNW hosts). Progress and the coach detail.
export const scheduleIdle = (run: () => void): (() => void) => {
  if (typeof requestIdleCallback === "function") {
    const id = requestIdleCallback(run);
    return () => cancelIdleCallback(id);
  }
  const id = setTimeout(run, 0);
  return () => clearTimeout(id);
};
